import React from 'react';
import { motion } from 'framer-motion';

export default function Gallery() {
  return (
    <section id="المعرض" className="pt-32 pb-24 min-h-screen bg-black">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-16">لقطات من <span className="text-neon-purple">المقاطعة</span></h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
          {[1, 2, 3, 4].map((item) => (
            <motion.div
              key={item}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: item * 0.15 }}
              className="aspect-square rounded-3xl bg-gray-900 border border-white/5 hover:border-neon-purple/50 hover:shadow-neon-purple transition-all duration-500 cursor-pointer overflow-hidden relative group"
            >
              <div className="absolute inset-0 bg-gradient-to-b from-transparent to-neon-purple/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="absolute inset-0 flex items-center justify-center translate-y-4 group-hover:translate-y-0 text-white/0 group-hover:text-white transition-all duration-300 font-bold text-xl">
                لقطة حصرية {item}
              </div>
              <div className="absolute top-4 left-4 w-2 h-2 rounded-full bg-neon-purple animate-ping"></div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}